import {
    HighestRiskCalculationType, RiskAssessmentStatus, ScreeningLocationType, ScreeningPolygonStatus
} from '../enums';
import { CaseWorker } from '../common';

export class LocationItem {
    public id: string;
    public number: string;
    public name: string;
    public region: number;

    public caseWorker: CaseWorker;

    // Screening
    public screeningLocationType: ScreeningLocationType;
    public polygonStatus: ScreeningPolygonStatus;
    public screeningFactor: number;
    public screeningPollutant: string;
    public screeningConcentration: number;
    public screeningAt: Date;

    // Risk assessment
    public calculationType: HighestRiskCalculationType;
    public riskAssessmentStatus: RiskAssessmentStatus;
    public factor: number;
    public contaminant: string;
    public concentration: number;

    public constructor(init: Partial<LocationItem>) {
        Object.assign(this, init);
    }
}
